import {
  AddTechSkillRequest,
  GetTechSkillAvailableResponse,
} from "./../../../types/api/techSkills.type";
import { QueryParam, ResourceId } from "../../../types/api/generic.type";
import {
  GetTechSkillsResponse,
  UpdateTechSkillRequest,
} from "../../../types/api/techSkills.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";
import { TechSkillPropertyEnum } from "../../../types/AppTypes";

const TechSkillsService = {
  async list(
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetTechSkillsResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";

    const response = await httpClient.get<GetTechSkillsResponse>(
      `v1/tech-skills?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
      { signal },
    );
    return response;
  },
  async getPropertyList(
    TechSkillPropertyNameEnum: TechSkillPropertyEnum,
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetTechSkillAvailableResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";

    const response = await httpClient.get<GetTechSkillAvailableResponse>(
      `v1/tech-skills/available/${TechSkillPropertyNameEnum}?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
      { signal },
    );
    return response;
  },
  async add(body: AddTechSkillRequest): Promise<ResourceId> {
    const response = await httpClient.post<AddTechSkillRequest, ResourceId>(
      "v1/tech-skills",
      body,
    );
    return response;
  },
  async update(
    techSkillId: number,
    body: UpdateTechSkillRequest,
  ): Promise<void> {
    await httpClient.put(`v1/tech-skills/${techSkillId}`, body);
  },
  async delete(techSkillId: number): Promise<void> {
    await httpClient.delete(`v1/tech-skills/${techSkillId}`);
  },
};

export default TechSkillsService;
